import { RangoClient } from 'rango-sdk';
import { API_KEY } from '../Constants';

export function getCookieId() {
  const key = 'deviceId';
  new RangoClient(API_KEY);
  const cookieId = window.localStorage.getItem(key) as string;
  return cookieId;
}
